/**
 * @generated SignedSource<<34be874d686f80c11b313d5180342a26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useCouponsRelayByIdQuery$variables = {
  id: string;
};
export type useCouponsRelayByIdQuery$data = {
  readonly getCoupon: {
    readonly active: boolean | null | undefined;
    readonly assignmentOnly: boolean;
    readonly code: string | null | undefined;
    readonly created: any | null | undefined;
    readonly discount: number | null | undefined;
    readonly discountType: string | null | undefined;
    readonly duration: number | null | undefined;
    readonly id: string;
    readonly name: string;
    readonly oldId: string | null | undefined;
    readonly organizationId: string | null | undefined;
    readonly systemId: string | null | undefined;
    readonly systemOldId: string | null | undefined;
    readonly uses: number | null | undefined;
    readonly validDays: number | null | undefined;
    readonly validFrom: any | null | undefined;
    readonly validTimeEnd: number | null | undefined;
    readonly validTimeStart: number | null | undefined;
    readonly validUntil: any | null | undefined;
  } | null | undefined;
};
export type useCouponsRelayByIdQuery = {
  response: useCouponsRelayByIdQuery$data;
  variables: useCouponsRelayByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Coupon",
    "kind": "LinkedField",
    "name": "getCoupon",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oldId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "active",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "discount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "discountType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "duration",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uses",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "systemId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "systemOldId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assignmentOnly",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "validDays",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "validTimeStart",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "validTimeEnd",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "validFrom",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "validUntil",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "created",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCouponsRelayByIdQuery",
    "selections": (v1/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCouponsRelayByIdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0fdd6844967493aa43afd98743fdbd41",
    "id": null,
    "metadata": {},
    "name": "useCouponsRelayByIdQuery",
    "operationKind": "query",
    "text": "query useCouponsRelayByIdQuery(\n  $id: ID!\n) {\n  getCoupon(id: $id) {\n    id\n    oldId\n    name\n    code\n    active\n    discount\n    discountType\n    duration\n    uses\n    systemId\n    systemOldId\n    organizationId\n    assignmentOnly\n    validDays\n    validTimeStart\n    validTimeEnd\n    validFrom\n    validUntil\n    created\n  }\n}\n"
  }
};
})();

(node as any).hash = "a72449fdd2974c3eb0c52ac189887349";

export default node;
